export default __webpack_public_path__ + "static/media/Waning Boundary.3351889f.jpg";